export default __webpack_public_path__ + "static/media/select-click.2604a56c.wav";